import {
  IS_DEV_ENV,
  IS_INTEGRATION_ENV
} from "../../shared/constants/environment";
import { tokenStore } from "./tokenStore";

export const shouldSendAnalyticsCall = (): boolean => {
  if (window.forceSendSegment) {
    return true;
  }

  if (!IS_INTEGRATION_ENV && (IS_DEV_ENV || window.TEST_ENV)) {
    return false;
  }

  return !tokenStore.isImpersonating();
};
